import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../translate';
import AcademyPaymentItem from '../AcademyPaymentItem';
import PriceProp from '../../../propTypes/priceProp';
import ImageProp from '../../../propTypes/imageProp';
import AcademyPaymentTabParticipants from '../AcademyPaymentTabParticipants';

function AcademyOrderDetail(props) {
  const {
    t,
    checkoutDetail,
    item,
    participants,
    targetUsers,
    onTargetEmailsChange,
    errors,
    typeOfItem,
    currentUserBoughtSession,
  } = props;
  return (
    <div>
      <div className="academy-title2-checkout">{t(typeOfItem.fieldId)}</div>
      <AcademyPaymentItem
        checkoutDetail={checkoutDetail}
        item={item}
        participants={participants}
      />
      <hr />
      {participants && (
        <AcademyPaymentTabParticipants
          item={item}
          checkoutDetail={checkoutDetail}
          targetUsers={targetUsers}
          onTargetEmailsChange={onTargetEmailsChange}
          errors={errors}
          currentUserBoughtSession={currentUserBoughtSession}
        />
      )}
    </div>
  );
}

AcademyOrderDetail.propTypes = {
  t: PropTypes.func.isRequired,
  checkoutDetail: PropTypes.shape({
    isPaidWithCoins: PropTypes.bool,
    total: PropTypes.number,
    item: PropTypes.shape({
      tax: PropTypes.number,
      total: PropTypes.number,
      price: PropTypes.number,
    }),
  }).isRequired,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    userPrice: PropTypes.shape(PriceProp.PropTypes),
    userPromotionPrice: PropTypes.shape(PriceProp.PropTypes),
    name: PropTypes.string.isRequired,
    image: PropTypes.shape(ImageProp.propType).isRequired,
  }).isRequired,
  participants: PropTypes.arrayOf(PropTypes.string),
  targetUsers: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  ),
  onTargetEmailsChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({})),
  typeOfItem: PropTypes.shape({
    fieldId: PropTypes.string.isRequired,
  }).isRequired,
  currentUserBoughtSession: PropTypes.bool.isRequired,
};

AcademyOrderDetail.defaultProps = {
  participants: null,
  targetUsers: null,
  errors: [],
};

export default translate(AcademyOrderDetail);
